import clsx from 'clsx';
import React, { forwardRef } from 'react';

interface Props extends Omit<React.HTMLProps<HTMLInputElement>, 'type'> {
  label?: string;
  invalid?: boolean;
}

const FileInput = forwardRef<HTMLInputElement, Props>(
  ({ label, name, className, invalid, ...rest }, ref) => {
    return (
      <div className="w-full flex flex-col space-y-2 border border-gray-300 shadow-sm rounded-md p-4 mt-4">
        {label && (
          <label htmlFor={name} className="text-sm text-gray-500">
            {label}
          </label>
        )}

        <input
          id={name}
          type="file"
          name={name}
          className={clsx(
            className
              ? className
              : `sm:text-sm${
                  invalid
                    ? ' border-red-500 focus:ring-red-500 focus:border-red-500'
                    : ' border-gray-300 focus:ring-primary focus:border-primary'
                }`
          )}
          {...rest}
        />
      </div>
    );
  }
);

FileInput.displayName = 'FileInput';

export default FileInput;
